import { platformAPI } from '@/utils/api';
import { isSheinShopAuthorized } from '@/shein-platform/constants/sheinRoutes';

export const SHEIN_SHOP_AUTH_EXPIRED_MESSAGE = '店铺授权已过期，请先在平台管理完成授权后再进入';

/** 当前工作区已授权（connected）的 SHEIN 店铺列表。 */
export async function listAuthorizedSheinShops() {
  const list = await platformAPI.listShops();
  const shops = Array.isArray(list) ? list : [];
  return shops.filter(
    (shop) => String(shop?.platformCode || '').toUpperCase() === 'SHEIN' && isSheinShopAuthorized(shop),
  );
}

/** 当前工作区是否存在已授权（connected）的 SHEIN 店铺。 */
export async function hasAuthorizedSheinShop() {
  const shops = await listAuthorizedSheinShops();
  return shops.length > 0;
}
